module.exports = __webpack_public_path__ + "0c9def64d4659603988075fe34f841c9.pdf";